/**
 * The query endpoints listed below are requested using the POST method
 * instead of the GET method.
 *
 * This is in place to get around an issue where some requests need to
 * send more data than fits in the URL.
 * This allows us to use the request body to send a bunch of data but
 * also gain the benefits of the Apollo cache.
 *
 * This file is auto-generated from endpointsToQueryAsPost.json.
 * Do not edit manually.
 */

import endpointsToQueryAsPost from '../../../../../schema/endpointsToQueryAsPost.json';

export default new Set(
  Object.entries(endpointsToQueryAsPost).reduce<string[]>(
    (acc, [key, value]) => (value ? [...acc, key] : acc),
    [],
  ),
);
